(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marketing-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initialiseCarousel(section) {
      if (!section || section.dataset.marketingVideosReady === 'true') return;

      var track = section.querySelector('[data-marketing-videos-track]');
      var slides = Array.from(section.querySelectorAll('[data-marketing-videos-slide]'));
      var leftButton = section.querySelector('[data-marketing-videos-left]');
      var rightButton = section.querySelector('[data-marketing-videos-right]');
      var dots = Array.from(section.querySelectorAll('[data-marketing-videos-dot]'));
      var soundButtons = Array.from(section.querySelectorAll('[data-marketing-videos-sound]'));
      var videos = Array.from(section.querySelectorAll('video'));
      var activeIndex = slides.length > 2 ? 1 : 0;
      var soundEnabled = false;
      var mediaReady = false;
      var rotationTimer;
      var pointerStartX = null;
      var transitionResetTimer;
      var lastDirection = 0;

      if (!track || !slides.length) return;
      section.dataset.marketingVideosReady = 'true';

      function relativePosition(index) {
        return (index - activeIndex + slides.length) % slides.length;
      }

      function shortestDistance(index) {
        var distance = index - activeIndex;
        var half = slides.length / 2;
        if (distance > half) distance -= slides.length;
        if (distance < -half) distance += slides.length;
        return distance;
      }

      function updateSoundButtons() {
        soundButtons.forEach(function (button) {
          var label = soundEnabled ? 'Unmuted' : 'Muted';
          button.classList.toggle('is-muted', !soundEnabled);
          button.setAttribute('aria-pressed', String(soundEnabled));
          button.setAttribute('aria-label', label);
          button.setAttribute('title', label);
        });
      }

      function applySoundState() {
        videos.forEach(function (video) {
          video.muted = !soundEnabled;
        });
        updateSoundButtons();
      }

      function loadVideo(video) {
        if (!video || video.dataset.marketingVideoLoaded === 'true') return;
        loadPoster(video);
        Array.from(video.querySelectorAll('source[data-src]')).forEach(function (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.dataset.marketingVideoLoaded = 'true';
        video.load();
      }

      function loadPoster(video) {
        if (!video || !video.dataset.poster) return;
        video.poster = video.dataset.poster;
        video.removeAttribute('data-poster');
      }

      function activateMedia() {
        if (mediaReady) return;
        mediaReady = true;
        assignPositions();
      }

      function assignPositions() {
        slides.forEach(function (slide, index) {
          var position = relativePosition(index);
          var distance = shortestDistance(index);
          var positionClass = 'is-after';
          var video = slide.querySelector('video');
          var isCentre = position === 0;

          if (isCentre) {
            positionClass = 'is-centre';
          } else if (distance === 1 || (slides.length === 2 && position === 1 && lastDirection >= 0)) {
            positionClass = 'is-right';
          } else if (distance === -1 || (slides.length === 2 && position === 1 && lastDirection < 0)) {
            positionClass = 'is-left';
          } else if (distance < 0) {
            positionClass = 'is-before';
          }

          slide.classList.remove('is-before', 'is-left', 'is-centre', 'is-right', 'is-after');
          slide.classList.add(positionClass);
          if (dots[index]) dots[index].classList.toggle('is-active', isCentre);

          if (!video) return;
          video.muted = !soundEnabled;
          if (mediaReady && (isCentre || positionClass === 'is-left' || positionClass === 'is-right')) {
            loadPoster(video);
          }
          if (isCentre && mediaReady) {
            loadVideo(video);
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      function resetHiddenPositions() {
        lastDirection = 0;
        slides.forEach(function (slide) { slide.classList.add('is-no-transition'); });
        assignPositions();
        window.requestAnimationFrame(function () {
          slides.forEach(function (slide) { slide.classList.remove('is-no-transition'); });
        });
      }

      function setActive(index, direction) {
        activeIndex = (index + slides.length) % slides.length;
        lastDirection = direction || 0;
        assignPositions();
        window.clearTimeout(transitionResetTimer);
        transitionResetTimer = window.setTimeout(resetHiddenPositions, 460);
      }

      if (leftButton) leftButton.addEventListener('click', function () { setActive(activeIndex - 1, -1); });
      if (rightButton) rightButton.addEventListener('click', function () { setActive(activeIndex + 1, 1); });

      slides.forEach(function (slide) {
        var soundButton = slide.querySelector('[data-marketing-videos-sound]');
        var video = slide.querySelector('video');
        if (!soundButton || !video) return;

        soundButton.addEventListener('click', function () {
          soundEnabled = !soundEnabled;
          applySoundState();
          loadVideo(video);
          video.play().catch(function () {});
        });
      });

      track.addEventListener('pointerdown', function (event) { pointerStartX = event.clientX; });
      track.addEventListener('pointerup', function (event) {
        if (pointerStartX === null) return;
        var distance = event.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(distance) < 35) return;
        setActive(distance < 0 ? activeIndex + 1 : activeIndex - 1, distance < 0 ? 1 : -1);
      });
      track.addEventListener('pointercancel', function () { pointerStartX = null; });

      function stopRotation() { window.clearInterval(rotationTimer); }
      function startRotation() {
        stopRotation();
      }

      function watchForMedia() {
        if (!videos.length) {
          mediaReady = true;
          return;
        }

        if (!('IntersectionObserver' in window)) {
          activateMedia();
          return;
        }

        var observerRootMargin = '180px 0px';
        if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
          observerRootMargin = '120px 0px';
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            activateMedia();
            observer.disconnect();
          });
        }, { rootMargin: observerRootMargin });

        observer.observe(section);
      }

      section.addEventListener('mouseenter', stopRotation);
      section.addEventListener('mouseleave', startRotation);
      section.addEventListener('focusin', stopRotation);
      section.addEventListener('focusout', function () {
        window.setTimeout(function () { if (!section.contains(document.activeElement)) startRotation(); }, 0);
      });

      applySoundState();
      assignPositions();
      watchForMedia();
    }

    document.querySelectorAll('[data-marketing-videos]').forEach(initialiseCarousel);
    document.addEventListener('shopify:section:load', function (event) { initialiseCarousel(event.target.querySelector('[data-marketing-videos]')); });
  })();

  } catch(e) { console.error(e); }
})();
})();
